import { VARIABLES } from '@environments/environment.variables';

export class DataCache {
  data: unknown;
  expiredAt: number;
  expirationTime: number;
  buildTimestamp: number;

  constructor(data: unknown, expirationTime: number) {
    this.data = data;
    this.expirationTime = expirationTime;
    this.expiredAt = expirationTime === 0 ? 0 : Date.now() + expirationTime * 1000;
    this.buildTimestamp = VARIABLES.buildTimestamp;
  }
}
